import React from 'react';
import { Box, Icon, BoxProps } from '@hover/blueprint';
import { iMic, iMicOff } from '@hover/icons';

interface Props extends BoxProps {
  isMuted?: boolean;
}

const WRAPPER_WIDTH = '56px';

const MuteUnmuteIcon: React.FC<Props> = ({ isMuted, ...rest }) => (
  <Box
    h={WRAPPER_WIDTH}
    w={WRAPPER_WIDTH}
    minW={WRAPPER_WIDTH}
    borderRadius="50%"
    alignItems="center"
    justifyContent="Center"
    bg="primary.900"
    position="absolute"
    zIndex={4}
    {...rest}
  >
    <Icon
      size="default"
      m={0}
      icon={isMuted ? iMicOff : iMic}
      color="neutral.0"
    />
  </Box>
);

MuteUnmuteIcon.defaultProps = {
  isMuted: false,
};

export default MuteUnmuteIcon;
